import { TextLink } from "@/components/links/TextLink";
import { SoftText } from "@/components/text/SoftText";

// The support line every error toast ends with, so the copy and the link stay identical across them.
export function ToastSupportFooter({ lead }: { lead: string }) {
  return (
    <>
      <hr className="my-1" />
      <SoftText elementType="p" className="text-xs">
        {lead}{" "}
        <TextLink href="/contact" external={false} className="text-xs">
          contact support
        </TextLink>
        .
      </SoftText>
    </>
  );
}
